import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { reactive, onMounted, onActivated, toRefs, watch, watchEffect, getCurrentInstance, ref } from "vue";
import apis from "@/api";
import QueryAssetsModal from '../components/QueryAssetsModal.vue';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
export default {
  components: {
    QueryAssetsModal
  },
  setup(props, ctx) {
    let data = reactive({
      formData: {
        id: '',
        positionId: '',
        assetsId: '',
        assetsName: '',
        actName: '',
        mustPut: 0,
        remark: ''
      },
      posData: [],
      assetDisabled: true,
      opType: 'add',
      cities: [],
      checkAll: false,
      checkedCities: [],
      isIndeterminate: true,
      dateRange: '',
      defaultTime: [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)],
      isMustPut: false,
      modalShow: false,
      maxDate: dayjs().add(1, 'year'),
      minDate: dayjs().add(-1, 'day')
    });
    onMounted(() => {
      apis.queryAreaList().then(res => {
        if (res.success) {
          data.cities = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
      apis.queryPositionTree("offline").then(res => {
        data.posData = res.data;
      });
    });
    const loadData = () => {
      apis.queryOffLPosBizById(data.formData.id).then(res => {
        if (res.success) {
          if (res.data.areaList.length > 0) {
            let areaListTmp = [];
            res.data.areaList.forEach(item => {
              areaListTmp.push(item.areaCode);
            });
            data.checkedCities = areaListTmp;
          }
          data.dateRange = [dayjs(res.data.bgnDate), dayjs(res.data.endDate)];
          data.formData.actName = res.data.actName;
          data.formData.positionId = res.data.positionId;
          data.formData.assetsId = res.data.assetBaseInfo.id;
          data.formData.assetsName = res.data.assetBaseInfo.assetsName;
          data.formData.bgnDate = res.data.bgnDate;
          data.formData.endDate = res.data.endDate;
          data.formData.mustPut = res.data.mustPut;
          data.isMustPut = res.data.mustPut === 1 ? true : false;
          data.formData.remark = res.data.remark;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const cleanField = () => {
      data.formData = {
        id: '',
        positionId: '',
        assetsId: '',
        assetsName: '',
        actName: '',
        mustPut: 0,
        remark: ''
      };
      data.assetDisabled = true;
      data.checkAll = false;
      data.checkedCities = [];
      data.isIndeterminate = true;
      data.dateRange = '';
      data.isMustPut = false;
    };
    const route = useRouter();
    onActivated(() => {
      let params = route.currentRoute.value.query;
      console.log(params, "onActivated");
      cleanField();
      if (params.id) {
        data.formData.id = params.id;
        loadData();
      }
      if (params.posId) {
        data.formData.positionId = params.posId;
        data.assetDisabled = false;
      }
      if (params.assetId) {
        queryAssetById(params.assetId);
        data.assetDisabled = false;
      }
      if (params.opType) {
        data.opType = params.opType;
      }
    });
    const defaultProps = {
      label: "nodeName",
      value: "id",
      children: "children",
      multiple: false,
      checkStrictly: false,
      leaf: "leaf"
    };
    const posChange = e => {
      data.formData.positionId = e[2];
      if (e[2]) {
        data.assetDisabled = false;
      } else {
        data.assetDisabled = true;
      }
    };
    const handleCheckAllChange = val => {
      console.log(val, "handleCheckAllChange");
      let areaCodes = [];
      data.cities.forEach(city => {
        areaCodes.push(city.areaCode);
      });
      data.checkedCities = val ? areaCodes : [];
      data.isIndeterminate = false;
    };
    const handleCheckedCitiesChange = value => {
      console.log(value, "handleCheckedCitiesChange");
      let checkedCount = value.length;
      data.checkAll = checkedCount === data.cities.length;
      data.isIndeterminate = checkedCount > 0 && checkedCount < data.cities.length;
    };
    const dateRangeChange = e => {
      data.formData.bgnDate = dayjs(e[0]).format("YYYY-MM-DD HH:mm:ss");
      data.formData.endDate = dayjs(e[1]).format("YYYY-MM-DD HH:mm:ss");
    };
    const disabledDate = currentDate => {
      return data.minDate.isAfter(currentDate) || data.maxDate.isBefore(currentDate);
    };
    const mustPutChange = e => {
      data.formData.mustPut = e ? 1 : 0;
    };
    const queryAssetById = id => {
      apis.queryAssetById(id).then(res => {
        chooseHandler(res.data);
      });
    };
    const chooseHandler = e => {
      console.log(e, "e");
      if (e && e.id) {
        data.formData.assetsId = e.id;
        data.formData.assetsName = e.assetsName;
        data.minDate = dayjs(e.bgnDate);
        data.maxDate = dayjs(e.endDate);
      }
    };
    const onSubmit = () => {
      if (!data.formData.positionId) {
        ElMessage.error("请选择投放运营位");
        return;
      }
      if (!data.formData.assetsId) {
        ElMessage.error("请选择投放素材");
        return;
      }
      if (data.checkedCities.length == 0) {
        ElMessage.error("请选择投放渠道");
        return;
      }
      let areaList = [];
      data.checkedCities.forEach(item => {
        areaList.push({
          areaCode: item
        });
      });
      data.formData.areaList = areaList;
      if (data.opType === 'clone') {
        data.formData.id = "";
      }
      if (!data.dateRange) {
        ElMessage.error("请选择投放有效期");
        return;
      }
      console.log(data.formData);
      apis.saveOrUpdateOffLPosBiz(data.formData).then(res => {
        if (res.success) {
          ElMessage.success("投放成功");
          cleanField();
          route.go(-1);
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    return {
      ...toRefs(data),
      handleCheckAllChange,
      handleCheckedCitiesChange,
      dateRangeChange,
      disabledDate,
      mustPutChange,
      defaultProps,
      posChange,
      onSubmit,
      chooseHandler,
      queryAssetById
    };
  }
};